import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  Divider,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Alert,
  Card,
  CardContent
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const ReviewSection = ({ projectId, data, onChange }) => {
  const [formData, setFormData] = useState(data || {
    additionalNotes: data?.additionalNotes || '',
    readyToSubmit: data?.readyToSubmit || 'yes'
  });
  
  // Update parent component when local state changes
  useEffect(() => {
    onChange(formData);
  }, [formData, onChange]);
  
  // Handle text field changes
  const handleTextChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value
    });
  };
  
  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Review & Submit
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Please review all the information you've provided before submitting. Once submitted, a Product Requirements Document (PRD) will be generated based on your responses.
      </Typography>
      
      <Alert severity="info" sx={{ mb: 3 }}>
        You can go back to any section using the navigation tabs above if you need to make changes.
      </Alert>
      
      <Divider sx={{ my: 3 }} />
      
      <Card variant="outlined" sx={{ mb: 4 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Completed Sections
          </Typography>
          
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="success" />
              </ListItemIcon>
              <ListItemText primary="Project Scope" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="success" />
              </ListItemIcon>
              <ListItemText primary="Target Audience" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="success" />
              </ListItemIcon>
              <ListItemText primary="User Volume" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="success" />
              </ListItemIcon>
              <ListItemText primary="Device Support" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="success" />
              </ListItemIcon>
              <ListItemText primary="Technology Stack" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="success" />
              </ListItemIcon>
              <ListItemText primary="Documentation" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="success" />
              </ListItemIcon>
              <ListItemText primary="Cloud Architecture" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="success" />
              </ListItemIcon>
              <ListItemText primary="Repository" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="success" />
              </ListItemIcon>
              <ListItemText primary="Database Schema" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="success" />
              </ListItemIcon>
              <ListItemText primary="Third-Party Integrations" />
            </ListItem>
          </List>
        </CardContent>
      </Card>
      
      <Paper elevation={1} sx={{ p: 3, mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Additional Notes
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Is there anything else the development team should know about this project?
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          placeholder="Add any additional information that should be included in the PRD..."
          value={formData.additionalNotes || ''}
          onChange={handleTextChange('additionalNotes')}
        />
      </Paper>
      
      <Alert severity="success" sx={{ mb: 4 }}>
        <Typography variant="subtitle1" fontWeight="bold">
          Ready to Generate Your PRD
        </Typography>
        <Typography variant="body2">
          Click the "Submit and Generate APD" button below to complete the questionnaire and generate your PRD document.
        </Typography>
      </Alert>
      
      <input 
        type="hidden" 
        name="readyToSubmit" 
        value="yes" 
        onChange={handleTextChange('readyToSubmit')}
      />
    </Box>
  );
};

export default ReviewSection;